module.exports = __webpack_public_path__ + "static/media/no_image.57f701ae.png";